import {
  Component,
  Input,
  ChangeDetectorRef,
  AfterContentChecked,
  OnInit,
} from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-text-area',
  templateUrl: './text-area.component.html',
  styleUrls: ['./text-area.component.scss'],
})
export class TextAreaComponent implements AfterContentChecked, OnInit {
  @Input() textFieldValue: string;

  @Input() placeholder = '';

  @Input() label: string;

  @Input() name;

  @Input() error = false;

  @Input() maxLength: string;

  @Input() minLength: string;

  @Input() inputMask: string;

  @Input() customMaskPatterns: string;

  @Input() hiddenInput: false;

  @Input() enableToggleTextButton = false;

  @Input() control: FormControl;

  @Input() submitted = false;

  constructor(private cdRef: ChangeDetectorRef) {}

  ngAfterContentChecked(): void {
    this.cdRef.detectChanges();
  }

  ngOnInit() {
    this.textFieldValue = this.control.value;
  }

  get errors(): boolean {
    if (this.control) {
      return this.control.invalid && (this.control.dirty || this.control.touched);
    }
  }
}
